import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { TypeContrato } from '@/features/agreement/utils/enum'

interface RegimeTributarioSelectorProps {
  value: string | null
  onChange: (value: string) => void
  error?: string
  className?: string
}

export const RegimeTributarioSelector = ({ value, onChange, error, className = '' }: RegimeTributarioSelectorProps) => {
  return (
    <div className={`text-foreground ${className}`}>
      <h3 className="text-lg font-semibold mb-2">Regime Tributário</h3>
      <RadioGroup onValueChange={onChange} value={value ?? undefined}>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value={TypeContrato.LUCRO_REAL} id={TypeContrato.LUCRO_REAL} />
          <Label htmlFor={TypeContrato.LUCRO_REAL}>Lucro Real</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value={TypeContrato.LUCRO_PRESUMIDO} id={TypeContrato.LUCRO_PRESUMIDO} />
          <Label htmlFor={TypeContrato.LUCRO_PRESUMIDO}>Lucro Presumido</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value={TypeContrato.SIMPLES_NACIONAL} id={TypeContrato.SIMPLES_NACIONAL} />
          <Label htmlFor={TypeContrato.SIMPLES_NACIONAL}>Simples Nacional</Label>
        </div>
      </RadioGroup>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  )
}

export default RegimeTributarioSelector
